module.exports = __webpack_public_path__ + "static/img/title-64px.8c06c0cc.png";